export default __webpack_public_path__ + "static/media/table_hero.b837b903.png";